import React, { useState } from 'react';
import './home_azul.css';
import Libro_Verde from './libro/Librover';
import { useTranslation } from 'react-i18next';
import Libro_azul from './libro_azul2/Libro_azul2';


function LibroBlanco_Azul() {

    const [t] = useTranslation("home");
    const [v, i18n] = useTranslation("librBlanc");

    const liga_lang1 = '/' + i18n.language + "/LibroNegocios";
    const liga_lang2 = '/' + i18n.language + "/LibroSociedades";

    const [activeTab, setActiveTab] = useState(1);

    const handleTabClick = (tabNumber) => {
        setActiveTab(tabNumber);
    };

    const [count, setCount] = React.useState(0);

    return (
        <div className='LibroBlanco_Azul'>

            <div class="conte_coleccion">
                <div class="NL_tit_coleccion">
                    <h1><spam class="amaril">{(v('header.tituColeci3'))}
                        {(v('header.tituColeci1'))}
                        <i>{(v('header.tituColeci2'))}</i>
                        {(v('header.tituColeci4'))}</spam></h1>
                </div>
            </div>



            <div className="content_home_azul2 animated fadeIn">
                {/* Contenido */}
                {activeTab === 1 && <Libro_azul></Libro_azul>}
                {activeTab === 2 && <Libro_Verde></Libro_Verde>}

            </div>


            <div className="row2 ideasescr">



                <div className={'col22_azul div-linea ' + (activeTab === 1 ? 'active' : '')}>
                    <p className="ideas" onClick={() => handleTabClick(1)}>{(v('books.blue'))}</p>
                    <div className="azul_2">
                    </div>
                    <div>
                        <a href={liga_lang1}>
                            <button class="btn_Mas_info">{(v('books.info'))}</button>
                        </a>
                    </div>
                </div>


                <div className={'col22_azul div-linea ' + (activeTab === 2 ? 'active' : '')}>
                    <p className="ideas" onClick={() => handleTabClick(2)}>{(v('books.green'))}</p>
                    <div className="verde_2"></div>
                    <div>
                        <a href={liga_lang2}>
                            <button class="btn_Mas_info">{(v('books.info'))}</button>
                        </a>
                    </div>

                </div>

            </div>




            <div className="row2 movil">
                <div className={'col21 div-linea ' + (activeTab === 1 ? 'active' : '')}
                    onClick={() => handleTabClick(1)}>
                    <div className="verde"></div>
                    <p className="ideas"> {(t('books.green-mobile'))}</p>

                </div>
                <div className={'col22 div-linea ' + (activeTab === 2 ? 'active' : '')}
                    onClick={() => handleTabClick(2)}>
                    <div className="gris"></div>
                    <p className="ideas"> {(t('books.white-mobile'))}</p>


                </div>
            </div>

        </div>
    );
}

export default LibroBlanco_Azul;